import {
    Box,
    Heading,
    Text,
    Center,
    VStack,
    Alert,
    AlertIcon,
    AlertTitle,
    AlertDescription,
    Icon,
    useStyleConfig,
} from '@chakra-ui/react';
import { EmailIcon } from '@chakra-ui/icons';
import { motion } from 'framer-motion';

export const VerificationNoticePage = () => {
    const styles = useStyleConfig('Alert', { variant: 'left-accent' });
    const urlParams = new URLSearchParams(window.location.search);
    const email = urlParams.get("email");
    return (
        <Center height="100vh" bg="gray.100">
            <motion.Box
                as={Box}
                p={8}
                borderRadius="md"
                shadow="md"
                maxWidth="md"
                textAlign="center"
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5 }}
            >
                <VStack spacing={8} textAlign="center">
                    <motion.div
                        style={{ display: 'inline-block' }}
                        animate={{ rotate: [0, 10, -10, 0] }}
                        transition={{ repeat: Infinity, duration: 1, ease: 'easeInOut' }}
                    >
                        <Icon as={EmailIcon} boxSize={12} color="blue.500" />
                    </motion.div>
                    <Alert status="info" borderRadius="md" sx={styles}>
                        <AlertIcon />
                        <Box textAlign="left">
                            <AlertTitle>Check Your Inbox</AlertTitle>
                            <AlertDescription>
                                A verification link has been sent to your email address <strong>{email}</strong>. Please
                                click the link in the email to verify your account.
                            </AlertDescription>
                        </Box>
                    </Alert>
                    <motion.div
                        initial={{ opacity: 0.7, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6, delay: 0.2 }}
                    >
                        <Heading as="h2" size="xl">
                            Welcome!
                        </Heading>
                        <Text fontSize="lg" mt={2}>
                            Thank you for signing up.
                        </Text>
                    </motion.div>
                    <motion.span as="span">
                        <Text fontSize="sm" color="gray.500">
                            If you don't see the email in your inbox, please check your spam
                            or junk folder.
                        </Text>
                    </motion.span>
                </VStack>
            </motion.Box>
        </Center>
    );
}
